import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import styled from '@xstyled/styled-components';
import { getSize, getColor, NumberInput } from '@lib/common';
import { Input, Select, Tooltip } from 'antd';
import Image from 'next/image';
import { useMemo } from 'react';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledLayout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  width: 100%;\n  padding: ", " ", ";\n  background-color: #faf8fc;\n  border-radius: ", ";\n  border: 1px solid #e2ebf0;\n"])), getSize('padding12'), getSize('padding12'), getSize('padding16'), getSize('radiusSm'));
var StyledIndexPrefix = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: #334155;\n  flex-shrink: 0;\n\n  min-width: 28px;\n\n  text-align: center;\n"])), getSize('typo14'));
var StyledQuestionInput = styled(Input)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  height: 40px;\n  border-radius: ", ";\n  border-color: #cbd5e1;\n\n  &:hover,\n  &:focus,\n  &.ant-input-focused {\n    border-color: ", ";\n  }\n\n  &:disabled {\n    background-color: #f8fafc;\n    cursor: not-allowed;\n  }\n"])), getSize('radiusS'), getColor('fillIntActive'));
var StyledAnswerSelect = styled(Select)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 200px;\n  flex-shrink: 0;\n\n  .ant-select-selector {\n    border-radius: ", " !important;\n    border-color: #cbd5e1 !important;\n    height: 40px !important;\n\n    &:hover,\n    &:focus {\n      border-color: ", " !important;\n    }\n  }\n\n  .ant-select-selection-item {\n    line-height: 38px !important;\n  }\n"])), getSize('radiusS'), getColor('fillIntActive'));
var StyledScoreInput = styled(NumberInput)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 140px;\n  height: 40px;\n\n  .ant-input-number-group-addon {\n    background-color: transparent;\n    border-left: none;\n    padding: 0 8px;\n    font-size: ", ";\n  }\n\n  .ant-input-number {\n    border-radius: ", " 0 0 ", " !important;\n    border-color: #cbd5e1;\n    height: 40px;\n\n    &:hover,\n    &:focus,\n    &.ant-input-number-focused {\n      border-color: ", ";\n    }\n  }\n\n  .ant-input-number-group-addon {\n    border-radius: 0 ", " ", " 0 !important;\n  }\n"])), getSize('typo12'), getSize('radiusS'), getSize('radiusS'), getColor('fillIntActive'), getSize('radiusS'), getSize('radiusS'));
var StyledActionButtonWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  flex-shrink: 0;\n\n  &:hover {\n    background-color: #f8fafc;\n    border-color: ", ";\n  }\n"])), getColor('fillIntActive'));
export var SubQuestionItem = function SubQuestionItem(_ref) {
  var index = _ref.index,
      subQuestion = _ref.subQuestion,
      matchedAnswer = _ref.matchedAnswer,
      answerOptions = _ref.answerOptions,
      score = _ref.score,
      onUpdateSubQuestion = _ref.onUpdateSubQuestion,
      onUpdateAnswer = _ref.onUpdateAnswer,
      onUpdateScore = _ref.onUpdateScore,
      onDelete = _ref.onDelete,
      readonly = _ref.readonly,
      baseLabel = _ref.baseLabel,
      matchingLabel = _ref.matchingLabel;
  var selectedAnswerId = matchedAnswer === null || matchedAnswer === void 0 ? void 0 : matchedAnswer.id.toString(); // Check if all answer options have empty descriptions

  var placeholder = useMemo(function () {
    if (answerOptions.length === 0) {
      return 'Select answer...';
    } // Check if at least one answer has a non-empty description


    var hasNonEmptyAnswer = answerOptions.some(function (option) {
      return option.label;
    }); // If all answers are empty and there's at least one answer, show "Empty answer"

    if (!hasNonEmptyAnswer && answerOptions.length > 0) {
      return 'Empty answer';
    } // Otherwise, show default placeholder


    return 'Select answer...';
  }, [answerOptions]);
  return /*#__PURE__*/_jsxs(StyledLayout, {
    children: [/*#__PURE__*/_jsxs(StyledIndexPrefix, {
      children: ["(", index, ")"]
    }), /*#__PURE__*/_jsx(StyledAnswerSelect, {
      value: selectedAnswerId,
      onChange: onUpdateAnswer,
      options: answerOptions,
      placeholder: placeholder,
      disabled: readonly
    }), /*#__PURE__*/_jsx(StyledQuestionInput, {
      defaultValue: subQuestion.description || '',
      onChange: function onChange(e) {
        return onUpdateSubQuestion(e.target.value);
      },
      placeholder: matchingLabel.subQuestionPlaceholder,
      disabled: readonly
    }), /*#__PURE__*/_jsx(StyledScoreInput, {
      defaultValue: score,
      onChange: function onChange(val) {
        return onUpdateScore(Number(val));
      },
      disabled: readonly,
      addonAfter: baseLabel.points,
      min: 0,
      max: 100,
      step: "0.25",
      stringMode: true
    }), onDelete && !readonly && /*#__PURE__*/_jsx(Tooltip, {
      title: matchingLabel.deleteSubQuestion,
      placement: "bottom",
      children: /*#__PURE__*/_jsx(StyledActionButtonWrapper, {
        onClick: onDelete,
        children: /*#__PURE__*/_jsx(Image, {
          src: "/icons/delete.svg",
          width: 16,
          height: 16,
          alt: "delete"
        })
      })
    })]
  });
};